import styled from "styled-components";
import { Modal } from "antd";

export const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-title {
    font-weight: 700;
  }

  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-modal-body {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
  }

  .ant-select,
  .ant-picker,
  .ant-input-affix-wrapper {
    width: 100%;
  }

  .add-tracking-time-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 16px;
  }

  .add-tracking-shifts {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .add-tracking-load-error {
    margin-bottom: 14px;
  }

  .add-tracking-validation-errors {
    margin-bottom: 14px;
  }

  .add-tracking-save-error {
    margin-bottom: 14px;
  }

  .add-tracking-shift {
    padding: 14px;
    background: #f8fafc;
    border: 1px solid #d9e2ec;
    border-radius: 8px;
  }

  .add-tracking-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    color: #173d68;
  }

  .add-tracking-breaks {
    padding-top: 12px;
    border-top: 1px solid #d9e2ec;
  }

  .add-tracking-break-row {
    display: grid;
    grid-template-columns: 64px minmax(0, 1fr) minmax(0, 1fr) 36px;
    align-items: center;
    gap: 12px;
  }

  .add-tracking-break-row .ant-form-item {
    margin-bottom: 12px;
  }

  .add-tracking-break-number {
    color: #52606d;
    font-weight: 600;
  }

  .add-tracking-add-button,
  .add-tracking-remove-button,
  .add-tracking-icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #2b3864;
    background: transparent;
    border: 0;
    cursor: pointer;
  }

  .add-tracking-add-button {
    min-height: 34px;
    padding: 4px 10px;
    border: 1px dashed #6376a5;
    border-radius: 6px;
  }

  .add-tracking-add-button:hover {
    color: #fff;
    background: #6376a5;
  }

  .add-tracking-add-button:disabled,
  .add-tracking-remove-button:disabled,
  .add-tracking-icon-button:disabled {
    color: #a0aec0;
    background: #f1f5f9;
    border-color: #cbd5e1;
    cursor: not-allowed;
  }

  .add-tracking-remove-button,
  .add-tracking-icon-button {
    color: #c0392b;
  }

  .add-tracking-icon-button {
    width: 36px;
    height: 36px;
    margin-top: 10px;
    padding: 0;
  }

  .add-tracking-add-shift {
    align-self: flex-start;
  }

  .add-tracking-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  @media screen and (max-width: 576px) {
    .add-tracking-time-fields {
      grid-template-columns: 1fr;
    }

    .add-tracking-break-row {
      grid-template-columns: 1fr 36px;
    }

    .add-tracking-break-number {
      grid-column: 1 / -1;
    }

    .add-tracking-break-row .ant-form-item {
      grid-column: 1;
    }

    .add-tracking-break-row .add-tracking-icon-button {
      grid-column: 2;
      grid-row: 3;
    }
  }
`;
